import styled from 'vue-styled-components';

import * as C from '../../styles';

export const Title = styled(C.ItemTitle)`
    width: 120px;
    flex-shrink: 0;
    color: var(--color-gray-130);
`;

export const Subtitle = styled(C.ItemTitle)`
    color: var(--color-gray-70);
`;

export const InternalLogo = styled.img`
    width: 16px;
    margin-right: 4px;
`;
